import { useMemo } from 'react';

import { usePermissionContext, useWorkspaceContext } from '../context';

export enum ComposableAnalyticsDataAccessEnum {
  WORKSPACE_DATA = 'WORKSPACE_DATA',
  TEAMS_DATA = 'TEAMS_DATA',
  LOGGED_IN_USER_DATA = 'LOGGED_IN_USER_DATA',
  CREATE_DASHBOARDS = 'CREATE_DASHBOARDS',
  CREATE_MASTER_DASHBOARDS = 'CREATE_MASTER_DASHBOARDS',
  SHARE_DASHBOARD = 'SHARE_DASHBOARD',
  PIN_DASHBOARD = 'PIN_DASHBOARD',
  ASSIGN_DASHBOARD = 'ASSIGN_DASHBOARD',
  RENAME_DASHBOARD = 'RENAME_DASHBOARD',
  DELETE_DASHBOARD = 'DELETE_DASHBOARD',
  UNPIN_DASHBOARD = 'UNPIN_DASHBOARD',
}

export const useComposableAnalyticsDataAccessHook = (
  actions: ComposableAnalyticsDataAccessEnum[]
) => {
  const workspace = useWorkspaceContext();
  const permissionContext = usePermissionContext();

  const data = useMemo(
    () =>
      actions.map(
        (action) =>
          !!workspace.role &&
          !!permissionContext.isAuthorized &&
          permissionContext.isAuthorized('COMPOSABLE_DATA_ACCESS', action, [workspace.role])
      ),
    [permissionContext, workspace.role]
  );

  return { access: data, owns: workspace.owns };
};
